import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 208 - 返回标题
 */
export default class EventBackTitle extends EventBase {
  constructor() {
    super()
    this.Parameter = ['1', '0', '0', '']
  }

  /**
   * 事件ID
   */
  public Code: EventID = EventID.BackTitle

  //   // #region 事件内主要属性参数
  /**
   * 是否淡出BGM (1是, 0否)
   */
  get IsOutBGM() {
    return this.Parameter && this.Parameter[0] == '1'
  }

  set IsOutBGM(val) {
    this.Parameter![0] = val ? '1' : '0'
  }

  /**
   * 是否为结局
   */
  get IsEnding() {
    return this.Parameter && this.Parameter[1] == '1'
  }

  set IsEnding(val) {
    this.Parameter![1] = val ? '1' : '0'
  }

  get isPic() {
    return this.Parameter?.[0] == '1'
  }
  set isPic(value) {
    this.Parameter && (this.Parameter[0] = value ? '1' : '0')
  }

  get PicFrame() {
    return parseInt(this.Parameter?.[1] ?? '0', 10) || 0
  }

  set PicFrame(value) {
    const next = Math.max(0, Math.round(Number(value) || 0))
    this.Parameter && (this.Parameter[1] = next.toString())
  }

  get IsFrameOrS() {
    return !!(this.Parameter?.[2] ?? '')
  }

  set IsFrameOrS(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '')
  }

  /**
   * 结局对应Id
   */
  get EndID() {
    return this.Parameter ? parseInt(this.Parameter[2]) : 0
  }

  set EndID(val) {
    this.Parameter![2] = val.toString()
  }
  // #endregion

  /**
   * 获得改时间在时间列表的描述信息
   * @returns 事件描述信息
   */
}
